import _ from 'lodash'

import { connect } from 'react-redux'

import Chart, { IChartProps } from './Chart'
import { IChartPoint, IState, } from './types'

// tslint:disable-next-line
export const CPUkeys: string[] = [
  'user-cpu',
  'system-cpu',
]

const mapStateToProps = (state: IState): IChartProps => {
  const data: IChartPoint[] = _
    .chain(state.chartPoints)
    .filter((point: IChartPoint) => point.chartType === 'CPU')
    .sortBy('timestamp')
    .value()

  return {
    data,
    keys: CPUkeys,
  }
}

export default connect(mapStateToProps)(Chart)



// WEBPACK FOOTER //
// ./src/CPU.tsx